import { render, staticRenderFns } from "./InvoicesAndTransaction.vue?vue&type=template&id=16066745&scoped=true&"
import script from "./InvoicesAndTransaction.vue?vue&type=script&lang=js&"
export * from "./InvoicesAndTransaction.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesAndTransaction.vue?vue&type=style&index=0&id=16066745&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16066745",
  null
  
)

export default component.exports